import type { SeriesListFilter } from '../../api/series.types'

export const SEARCH_STORAGE_KEY = 'series.list.search'

// Logout drops the remembered search so the next user never sees it.
export const clearSeriesListSearch = (): void => {
  try {
    sessionStorage.removeItem(SEARCH_STORAGE_KEY)
  } catch {
    // storage unavailable: nothing was kept
  }
}

const MAX_PAGE = 100000
const STATUSES = ['active', 'completed', 'cancelled', 'all'] as const

type ListParams = Omit<SeriesListFilter, 'search'>

const toPositiveInt = (raw: string | null): number | null => {
  if (raw === null || !/^\d+$/.test(raw)) return null
  const value = Number(raw)
  return Number.isSafeInteger(value) && value >= 1 ? value : null
}

export const parseListParams = (params: URLSearchParams): ListParams => {
  const status = STATUSES.find((s) => s === params.get('status')) ?? 'active'
  const page = toPositiveInt(params.get('page'))
  return {
    status,
    doctorId: toPositiveInt(params.get('doctor')),
    page: page === null ? 1 : Math.min(page, MAX_PAGE),
  }
}

export const writeListParams = (filter: ListParams): Record<string, string> => ({
  ...(filter.status !== 'active' ? { status: filter.status } : {}),
  ...(filter.doctorId !== null ? { doctor: String(filter.doctorId) } : {}),
  ...(filter.page !== 1 ? { page: String(filter.page) } : {}),
})
